export default function copyTextToClipboard(text) {
    if (!text) return false;

    var targetId = "_hiddenCopyText_";
    var target = document.getElementById(targetId);

    // Create hidden textarea if not exists
    if (!target) {
        target = document.createElement("textarea");
        target.id = targetId;

        target.style.position = "fixed";      // better than absolute
        target.style.top = "-1000px";         // fully off-screen
        target.style.left = "-1000px";
        target.style.opacity = "0";           // visually invisible

        document.body.appendChild(target);
    }

    target.value = text;  // Use value instead of textContent for textarea

    // Save current focus
    var currentFocus = document.activeElement;

    // Select the text
    target.focus();
    target.select();

    let succeed = false;
    try {
        succeed = document.execCommand("copy");
    } catch (e) {
        succeed = false;
    }

    // Restore focus
    if (currentFocus && typeof currentFocus.focus === "function") {
        currentFocus.focus();
    }

    // Clear content
    target.value = "";

    return succeed;
}
